// Sound captions (§14.4, §14.5, §25): the engine fills `captions` whether or not audio is unlocked
// or muted, so the caption UI works for players who cannot hear. Times are in the frame clock (ms).
export interface Caption { text: string; until: number }

export const CAPTION_MAX = 6;
const DEFAULT_SEC = 1.6;

export class Captions {
  /** Live list (the §25 `captions` array, mutated in place). */
  readonly list: Caption[] = [];

  /** Adds a caption, or extends a live one with the same text. */
  push(text: string, now: number, sec = DEFAULT_SEC): void {
    if (!text) return;
    const until = now + sec * 1000;
    const live = this.list.find((c) => c.text === text && c.until > now);
    if (live) {
      live.until = Math.max(live.until, until);
      return;
    }
    this.prune(now);
    this.list.push({ text, until });
    while (this.list.length > CAPTION_MAX) this.list.shift();
  }

  prune(now: number): void {
    for (let i = this.list.length - 1; i >= 0; i--) if (this.list[i].until <= now) this.list.splice(i, 1);
  }
}
